import models from 'plugins/i18n/modelTypes.en.ts'

export default {
	activityFeed: {
		title: 'Activities / Updates',
		from: 'from',
		created: 'created',
		edited: 'edited',
		field_updated: '{field} was updated from {from} to {to}',
		model: { ...models },
	},
}
